import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/user/deals/trendingDeals.css";
import "../../../../assets/css/user/featuredDeals/FeaturedDeals.css";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import TpDealCard from "../../../../components/user/card/dealCard/TpDealCard";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TrendingDeals = () => {
  const navigate = useNavigate();

  const [trendingDeals, setTrendingDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const { baseUrl } = useContext(AppContext);

  const fetchTrendingDeals = () => {
    setLoading(true);

    axios
      .post(`${baseUrl}/customer/deals/fetchTrendingDeals`)
      .then((response) => {
        setTrendingDeals(response.data?.deals || []);
      })
      .catch((error) => {
        console.log(error);
        setTrendingDeals([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchTrendingDeals();
  }, []);

  return (
    <section className="trending-deals">
      {/* Section Header */}
      <div className="fd-header">
        <div>
          <h2 className="fd-title">Trending Deals</h2>
          <p className="fd-subtitle">
            Discover what's trending right now
          </p>
        </div>

        <button
          className="fd-view-all"
          onClick={() => navigate("/deals?type=trending")}
        >
          View All <ArrowRight size={16} />
        </button>
      </div>

      <Container fluid className="fd-container">
        {loading ? (
          /* Loader */
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "250px" }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : (
          /* Deals */
          <Row className="fd-grid gx-4 gy-4">
            {(trendingDeals || []).map((deal) => (
              <Col
                key={deal.id}
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={10}
                xs={12}
                className="fd-col"
              >
                <div className="fd-card-wrapper">
                  <TpDealCard deal={deal} />
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </section>
  );
};

export default TrendingDeals;